<template>
    <div ref="playerRef">
    </div>
</template>

<script setup>
    import { ref, onMounted, defineEmits } from 'vue';
    import Player from '@vimeo/player';

    const props = defineProps({
        videoId: String,
    });

    const emit = defineEmits(['on-player-loaded']);

    const playerRef = ref(null);
    let player = null;


    onMounted(() => {
        player = new Player(playerRef.value, {
            id: props.videoId,
            dnt: true,
        });
        player.ready().then(() => {
            emit('on-player-loaded', player);
        });
        player.on('playing', function() {
            emit('on-play');
        });
        // player.on('pause', function() {
        //     emit('on-pause');
        // });
    });

</script>